import { Grid, type GridProps } from '@mui/material';
import type { FC } from 'react';

export type GridItemProps = Omit<GridProps, 'container' | 'item' | 'spacing'> & { component?: string };

export const GridItem: FC<GridItemProps> = (props) => {
  return <Grid item {...props} />;
};
